import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  id: "iam_familia_prioritaria"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("FamiliaPrioritariaModalTitulo")), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", {
          class: "modal-body",
          innerHTML: _ctx.$t('FamiliaPrioritariaModalBody')
        }, null, 8, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t("FamiliaPrioritariaModalButton")), 1)
        ])
      ])
    ])
  ]))
}